__turbopack_context__.v({
  "bg": "Popup-module__BlCpBW__bg",
  "bg__pop_up": "Popup-module__BlCpBW__bg__pop_up",
  "bg__pop_up__close": "Popup-module__BlCpBW__bg__pop_up__close",
  "bg__pop_up__img": "Popup-module__BlCpBW__bg__pop_up__img",
  "bg__pop_up__info": "Popup-module__BlCpBW__bg__pop_up__info",
  "bg__pop_up__info__banner": "Popup-module__BlCpBW__bg__pop_up__info__banner",
  "bg__pop_up__info__banner__img": "Popup-module__BlCpBW__bg__pop_up__info__banner__img",
  "bg__pop_up__info__banner__text": "Popup-module__BlCpBW__bg__pop_up__info__banner__text",
  "bg__pop_up__info__texts": "Popup-module__BlCpBW__bg__pop_up__info__texts",
  "bg__pop_up__info__texts__description": "Popup-module__BlCpBW__bg__pop_up__info__texts__description",
  "bg__pop_up__info__texts__pretitle": "Popup-module__BlCpBW__bg__pop_up__info__texts__pretitle",
  "bg__pop_up__info__texts__subtitle": "Popup-module__BlCpBW__bg__pop_up__info__texts__subtitle",
  "bg__pop_up__info__texts__title": "Popup-module__BlCpBW__bg__pop_up__info__texts__title",
});
